import { Theme } from '../../../src/types/index.js'

export const theme: Theme = {
  id: 'summer-atmosphere',
  name: 'Summer atmosphere',
  palette: {
    primary: '#F18F2E',
    accent: '#2AC864',
    neutral: '#EEFBF9',
  },
  light1: {
    'action-primary': '#e48a0f',
    'action-primary-hovered': '#e29b39',
    'action-primary-pressed': '#c2760c',
    'action-primary-subdued': '#fff5e8',
    'action-primary-subdued-hovered': '#feecd5',
    'action-primary-subdued-pressed': '#fde8cd',
    'action-primary-disabled': '#f7f8f8',
    'action-neutral': '#ffffff',
    'action-neutral-hovered': '#f2fafa',
    'action-neutral-pressed': '#e4f3f3',
    'action-neutral-subdued': '#f0f0f2',
    'action-neutral-subdued-hovered': '#e3e7e8',
    'action-neutral-subdued-pressed': '#ced5d6',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f0f2f3',
    background: '#F4FAF9',
    'background-hovered': '#ffffff',
    'background-pressed': '#d3f1e5',
    'background-selected': '#ced5d6',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#96a4a8',
    content: '#01151A',
    'content-subdued': '#3f575e',
    'content-muted': '#61757b',
    'content-hovered': '#001a21',
    'content-pressed': '#3f575e',
    'content-disabled': '#96a4a8',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#d37e0b',
    'content-on-primary': '#fff2f2',
    'content-on-inverse': '#f7f8f8',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#01151A',
    'content-on-background-subdued': '#385556',
    'content-on-background-hovered': '#001a21',
    'content-on-background-pressed': '#385556',
    'content-on-background-disabled': '#96a4a8',
    interactive: '#1e9d7f',
    'interactive-hovered': '#47e0bc',
    'interactive-pressed': '#1c594b',
    'interactive-disabled': '#f7f8f8',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f3f7ff',
    topbar: '#ffffff',
    'topbar-subdued': '#f5f5f9',
    'content-on-topbar': '#2c3232',
    'line-on-topbar': '#ced5d6',
    'line-on-topbar-pressed': '#83b7ae',
    link: '#1bc250',
    'link-hovered': '#19a043',
    'link-pressed': '#103e0c',
    line: '#dce9ec',
    'line-subdued': '#dce9ec',
    'line-hovered': '#90a8ae',
    'line-pressed': '#7aa099',
    'line-selected': '#3f575e',
    'line-disabled': '#e3e7e8',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#1bc250',
    skeleton: '#e3e7e8',
    surface: '#FFFFFF',
    'surface-subdued': '#F2FAF7',
    'surface-hovered': '#F4FDFA',
    'surface-subdued-hovered': '#e3e7e8',
    'surface-pressed': '#e8efee',
    'surface-disabled': '#f7f8f8',
    'surface-selected': '#e8f4f2',
    'surface-selected-hovered': '#fcf1ef',
    'surface-selected-pressed': '#fae0dc',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#F1F9F6',
    'surface-neutral-subdued': '#f7f8f8',
    'surface-inverse': '#001a21',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light2: {
    'action-primary': '#e48a0f',
    'action-primary-hovered': '#e29b39',
    'action-primary-pressed': '#c2760c',
    'action-primary-subdued': '#fff5e8',
    'action-primary-subdued-hovered': '#feecd5',
    'action-primary-subdued-pressed': '#fde8cd',
    'action-primary-disabled': '#f7f8f8',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#f2fafa',
    'action-neutral-pressed': '#e4f3f3',
    'action-neutral-subdued': '#f0f0f2',
    'action-neutral-subdued-hovered': '#e3e7e8',
    'action-neutral-subdued-pressed': '#ced5d6',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f0f2f3',
    background: '#FFFFFF',
    'background-hovered': '#fefff2',
    'background-pressed': '#e8f4f2',
    'background-selected': '#e3e7e8',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#96a4a8',
    content: '#000000',
    'content-subdued': '#3f575e',
    'content-muted': '#61757b',
    'content-hovered': '#001a21',
    'content-pressed': '#3f575e',
    'content-disabled': '#96a4a8',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#d37e0b',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f7f8f8',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#000000',
    'content-on-background-subdued': '#385556',
    'content-on-background-hovered': '#001a21',
    'content-on-background-pressed': '#1e6466',
    'content-on-background-disabled': '#96a4a8',
    interactive: '#1e9d7f',
    'interactive-hovered': '#47e0bc',
    'interactive-pressed': '#1c594b',
    'interactive-disabled': '#f7f8f8',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f3f7ff',
    topbar: '#FFFFFF',
    'topbar-subdued': '#f0f2f3',
    'content-on-topbar': '#000000',
    'line-on-topbar': '#ced5d6',
    'line-on-topbar-pressed': '#83b7ae',
    link: '#29c21b',
    'link-hovered': '#209815',
    'link-pressed': '#103e0c',
    line: '#ced5d6',
    'line-subdued': '#dce9ec',
    'line-hovered': '#96a4a8',
    'line-pressed': '#859f9a',
    'line-selected': '#3f575e',
    'line-disabled': '#e3e7e8',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#1bc250',
    skeleton: '#e3e7e8',
    surface: '#FFFFFF',
    'surface-subdued': '#F2FAF7',
    'surface-hovered': '#f0f2f3',
    'surface-subdued-hovered': '#e3e7e8',
    'surface-pressed': '#e8efee',
    'surface-disabled': '#f7f8f8',
    'surface-selected': '#e8f4f2',
    'surface-selected-hovered': '#fcf1ef',
    'surface-selected-pressed': '#fae0dc',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#F1F9F6',
    'surface-neutral-subdued': '#f7f8f8',
    'surface-inverse': '#001a21',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light3: {
    'action-primary': '#e48a0f',
    'action-primary-hovered': '#e29b39',
    'action-primary-pressed': '#c2760c',
    'action-primary-subdued': '#fff5e8',
    'action-primary-subdued-hovered': '#feecd5',
    'action-primary-subdued-pressed': '#fde8cd',
    'action-primary-disabled': '#f7f8f8',
    'action-neutral': '#F4FAF9',
    'action-neutral-hovered': '#f2f7f7',
    'action-neutral-pressed': '#e4f3f3',
    'action-neutral-subdued': '#f0f0f2',
    'action-neutral-subdued-hovered': '#e3e7e8',
    'action-neutral-subdued-pressed': '#ced5d6',
    'action-neutral-disabled': '#f7f8f8',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f0f2f3',
    background: '#FFFFFF',
    'background-hovered': '#f7fffe',
    'background-pressed': '#F4FAF9',
    'background-selected': '#e3e7e8',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#96a4a8',
    content: '#01151A',
    'content-subdued': '#3f575e',
    'content-muted': '#61757b',
    'content-hovered': '#001a21',
    'content-pressed': '#3f575e',
    'content-disabled': '#96a4a8',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#d37e0b',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f7f8f8',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#01151A',
    'content-on-background-subdued': '#3f575e',
    'content-on-background-hovered': '#001a21',
    'content-on-background-pressed': '#0e4b2c',
    'content-on-background-disabled': '#96a4a8',
    interactive: '#1e9d7f',
    'interactive-hovered': '#47e0bc',
    'interactive-pressed': '#1c594b',
    'interactive-disabled': '#f7f8f8',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f3f7ff',
    topbar: '#F4FAF9',
    'topbar-subdued': '#e8f5f3',
    'content-on-topbar': '#4a6666',
    'line-on-topbar': '#cedddf',
    'line-on-topbar-pressed': '#83b7ae',
    link: '#29c21b',
    'link-hovered': '#209815',
    'link-pressed': '#103e0c',
    line: '#dce9ec',
    'line-subdued': '#F4FAF9',
    'line-hovered': '#90a8ae',
    'line-pressed': '#7aa099',
    'line-selected': '#3f575e',
    'line-disabled': '#e3e7e8',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#1bc250',
    skeleton: '#e3e7e8',
    surface: '#F4FAF9',
    'surface-subdued': '#f9f9f9',
    'surface-hovered': '#fdfdfd',
    'surface-subdued-hovered': '#ced5d6',
    'surface-pressed': '#e8f4f2',
    'surface-disabled': '#f7f8f8',
    'surface-selected': '#e8f4f2',
    'surface-selected-hovered': '#fcf5f0',
    'surface-selected-pressed': '#faebdc',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#e3e7e8',
    'surface-neutral-subdued': '#f7f8f8',
    'surface-inverse': '#001a21',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark1: {
    'action-primary': '#e48a0f',
    'action-primary-hovered': '#e29b39',
    'action-primary-pressed': '#c2760c',
    'action-primary-subdued': '#52422a',
    'action-primary-subdued-hovered': '#6c5839',
    'action-primary-subdued-pressed': '#3e3220',
    'action-primary-disabled': '#314348',
    'action-neutral': '#11181A',
    'action-neutral-hovered': '#21383e',
    'action-neutral-pressed': '#314348',
    'action-neutral-subdued': '#182b30',
    'action-neutral-subdued-hovered': '#314348',
    'action-neutral-subdued-pressed': '#314348',
    'action-neutral-disabled': '#314348',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#314348',
    background: '#0A0E0F',
    'background-hovered': '#182b3080',
    'background-pressed': '#17362e',
    'background-selected': '#182b30',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#9aa3a6',
    content: '#f6fafa',
    'content-subdued': '#BCC5BE',
    'content-muted': '#9aa3a6',
    'content-hovered': '#e8eded',
    'content-pressed': '#d1d5d6',
    'content-disabled': '#667478',
    'content-on-positive': '#f4faf6',
    'content-on-attention': '#fff7f1',
    'content-on-highlight': '#f4f9fd',
    'content-on-negative': '#fff6f4',
    'content-on-negative-hovered': '#ffefec',
    'content-on-negative-pressed': '#ffdfda',
    'content-primary': '#fff9f9',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#07191e',
    'content-on-destructive': '#f7f7f8',
    'content-on-interactive': '#c9d1d8',
    'content-on-background': '#f6fafa',
    'content-on-background-subdued': '#c0cccc',
    'content-on-background-hovered': '#e7ead6',
    'content-on-background-pressed': '#b4edda',
    'content-on-background-disabled': '#667478',
    interactive: '#29836e',
    'interactive-hovered': '#35b799',
    'interactive-pressed': '#1c594b',
    'interactive-disabled': '#07191e',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#07191e',
    topbar: '#11181A',
    'topbar-subdued': '#131b1d',
    'content-on-topbar': '#f7f7f8',
    'line-on-topbar': '#314348',
    'line-on-topbar-pressed': '#667478',
    link: '#9ce695',
    'link-hovered': '#66b35f',
    'link-pressed': '#437f3e',
    line: '#0b2f3a',
    'line-subdued': '#112a32',
    'line-hovered': '#1d4754',
    'line-pressed': '#667478',
    'line-selected': '#46565b',
    'line-disabled': '#314348',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#041828',
    'line-highlight-subdued': '#041828',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#9ce695',
    skeleton: '#1e2b2f',
    surface: '#11181A',
    'surface-subdued': '#021317',
    'surface-hovered': '#0a2127',
    'surface-subdued-hovered': '#010506',
    'surface-pressed': '#021317',
    'surface-disabled': '#314348',
    'surface-selected': '#226e5b',
    'surface-selected-hovered': '#6a9468',
    'surface-selected-pressed': '#14493c',
    'surface-attention': '#3c220a',
    'surface-attention-subdued': '#5b3814',
    'surface-negative': '#4a1712',
    'surface-negative-subdued': '#712821',
    'surface-negative-subdued-hovered': '#90372e',
    'surface-negative-subdued-pressed': '#90372e',
    'surface-positive': '#0b2e1a',
    'surface-positive-subdued': '#17492d',
    'surface-highlight': '#092a42',
    'surface-highlight-subdued': '#154365',
    'surface-highlight-subdued-hovered': '#1f5880',
    'surface-highlight-subdued-pressed': '#1f5880',
    'surface-neutral': '#0b282f',
    'surface-neutral-subdued': '#314348',
    'surface-inverse': '#f7f7f8',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark2: {
    'action-primary': '#e48a0f',
    'action-primary-hovered': '#e29b39',
    'action-primary-pressed': '#c2760c',
    'action-primary-subdued': '#52422a',
    'action-primary-subdued-hovered': '#6c5839',
    'action-primary-subdued-pressed': '#3e3220',
    'action-primary-disabled': '#314348',
    'action-neutral': '#07191e',
    'action-neutral-hovered': '#182b30',
    'action-neutral-pressed': '#314348',
    'action-neutral-subdued': '#182b30',
    'action-neutral-subdued-hovered': '#314348',
    'action-neutral-subdued-pressed': '#314348',
    'action-neutral-disabled': '#182b30',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#314348',
    background: '#11181A',
    'background-hovered': '#01151A',
    'background-pressed': '#3E320C',
    'background-selected': '#010b0e',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#9aa3a6',
    content: '#f6fafa',
    'content-subdued': '#d6dfe1',
    'content-muted': '#9aa3a6',
    'content-hovered': '#e8eded',
    'content-pressed': '#d2d8b2',
    'content-disabled': '#667478',
    'content-on-positive': '#f4faf6',
    'content-on-attention': '#fff7f1',
    'content-on-highlight': '#f4f9fd',
    'content-on-negative': '#fff6f4',
    'content-on-negative-hovered': '#ffefec',
    'content-on-negative-pressed': '#ffdfda',
    'content-primary': '#EBEDDF',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#07191e',
    'content-on-destructive': '#f7f7f8',
    'content-on-interactive': '#f6fafa',
    'content-on-background': '#f6fafa',
    'content-on-background-subdued': '#f6fafa',
    'content-on-background-hovered': '#e7ead6',
    'content-on-background-pressed': '#f7e2c4',
    'content-on-background-disabled': '#667478',
    interactive: '#29836e',
    'interactive-hovered': '#35b799',
    'interactive-pressed': '#1c594b',
    'interactive-disabled': '#07191e',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#07191e',
    topbar: '#0A0E0F',
    'topbar-subdued': '#060809',
    'content-on-topbar': '#e4edef',
    'line-on-topbar': '#314348',
    'line-on-topbar-pressed': '#667478',
    link: '#9ce695',
    'link-hovered': '#66b35f',
    'link-pressed': '#437f3e',
    line: '#0b2f3a',
    'line-subdued': '#112a32',
    'line-hovered': '#1d4754',
    'line-pressed': '#667478',
    'line-selected': '#46565b',
    'line-disabled': '#314348',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#041828',
    'line-highlight-subdued': '#041828',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#9ce695',
    skeleton: '#1e2b2f',
    surface: '#0A0E0F',
    'surface-subdued': '#05191e',
    'surface-hovered': '#011F26',
    'surface-subdued-hovered': '#314348',
    'surface-pressed': '#314348',
    'surface-disabled': '#182b30',
    'surface-selected': '#226e5b',
    'surface-selected-hovered': '#6a9468',
    'surface-selected-pressed': '#14493c',
    'surface-attention': '#3c220a',
    'surface-attention-subdued': '#5b3814',
    'surface-negative': '#4a1712',
    'surface-negative-subdued': '#712821',
    'surface-negative-subdued-hovered': '#90372e',
    'surface-negative-subdued-pressed': '#90372e',
    'surface-positive': '#0b2e1a',
    'surface-positive-subdued': '#17492d',
    'surface-highlight': '#092a42',
    'surface-highlight-subdued': '#154365',
    'surface-highlight-subdued-hovered': '#1f5880',
    'surface-highlight-subdued-pressed': '#1f5880',
    'surface-neutral': '#011F26',
    'surface-neutral-subdued': '#243c43',
    'surface-inverse': '#f7f7f8',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
}
